import React from 'react'
import Navbar from '../Navbar/Navbar'
import "./Question_1.css"
import { Link } from 'react-router-dom'

const Question_1 = () => {
  return (
    <div className='portal-kiga-question-1-main'>
      <Navbar/>
      <section className='portal-kiga-question-1-section'>
       <div className='portal-kiga-question-1-section-header'>
        <p>Need help finding the right class?</p>
       </div>
       <div className='portal-kiga-question-1-section-btn-yes'>
        <Link to='/portal/booking/wizard-question-2'>
        <p>yes, please</p>   
        </Link>
       </div>
       <div className='portal-kiga-question-1-section-btn-no'>
         <p>no, just looking</p>
       </div> 
      </section>
      <footer className='portal-kiga-question-1-footer'>

        <div className='portal-kiga-question-1-footer-close'>
         <div className='portal-kiga-question-1-footer-close-btn'>
          <Link to="/">X</Link>
         </div>
         <div className='portal-kiga-question-1-footer-close-title'>
          <p>Cancel</p>
         </div>
        </div>

        <div className='portal-kiga-question-1-footer-right'>
         <div className='portal-kiga-question-1-footer-right-btn'>
          <Link to="/">{'>'}</Link>
         </div>
         <div className='portal-kiga-question-1-footer-right-title'>
          <p>Next</p>
         </div>
        </div>

      </footer>
    </div>
  )
}

export default Question_1